import React from "react";
import "./DriveWithUS.css";
import Loader from "../Loader/Loader";
const DriveWithUS = () => {
  return (
    <>
    <Loader/>
      <div className="mainOurServices">
        <div className="ourServiceTxt">Drive With Us</div>

        <div className="middleLine"></div>
        <div className="ourServTxtPara">
          Explore The UK With Experienced Drivers.
        </div>
      </div>

      <div className="driveWithUsFormMain">
        <div className="headingDriveUs">Drive with us</div>
        <div className="driveWithUsFormMTxt">
          Please provide us with as much information as possible so we can help
          you quickly and effectively.
        </div>
        <div className="mainInnerFormDrive">
          <div className="topInputTxtDrive">
            <div className="inputLblTxtDrive">First Name</div>
            <input placeholder="First Name"
            className="inputFormDrive"
            
            />
          </div>
          <div className="topInputTxtDrive">
            <div className="inputLblTxtDrive">Last Name</div>
            <input placeholder="Last Name"
            className="inputFormDrive"
            
            />
          </div>
          <div className="topInputTxtDrive">
            <div className="inputLblTxtDrive">Email Address</div>
            <input placeholder="Email Address"
            className="inputFormDrive"
            
            />
          </div>
          <div className="topInputTxtDrive">
            <div className="inputLblTxtDrive">Phone Number</div>
            <input placeholder="Phone Number"
            className="inputFormDrive"
            
            />
          </div>
          <div className="driveWithUsFormMTxt">
          Please enter your bookings details or comments
        </div>
        <textarea
        className="inputFormDrive1"
        placeholder="Please enter the full details of your booking requirements or comments"
        rows={5}
      // cols={10}
        />
        {/* <textarea rows="4"></textarea> */}


        <div className="btnQuerySubmit">Submit Query</div>

        </div>
      </div>
    </>
  );
};

export default DriveWithUS;
